import { FRAGMENT_CLAIMS, captureFragmentCredential, clearFragmentCredential } from './fragmentCredentials'

let passwordSetupToken = captureFragmentCredential(FRAGMENT_CLAIMS.passwordSetup)

export const getPasswordSetupToken = () => passwordSetupToken

export const clearPasswordSetupToken = () => {
  passwordSetupToken = null
  clearFragmentCredential(FRAGMENT_CLAIMS.passwordSetup)
}
